import type { QueryClient } from "@tanstack/react-query"
import type { Friend } from "@/entities/friend"
import {
	checkPermission,
	type Intent,
	type User,
	type UserPermissionKey,
} from "@/entities/user"
import { showAccessDeniedPopup } from "./access-denied"

export async function requirePermission({
	intent,
	...check
}: {
	queryClient: QueryClient
	user: User
	permission: UserPermissionKey
	intent: Intent | null
	fresh?: boolean
}): Promise<boolean> {
	const result = await checkPermission(check)
	switch (result.outcome) {
		case "allowed":
			return true
		case "session_lost":
			return false
		case "denied":
			showAccessDeniedPopup(result.denial, intent)
			return false
	}
}

export async function requireChatPermission({
	friend,
	...rest
}: {
	queryClient: QueryClient
	user: User
	friend: Friend
	fresh?: boolean
}): Promise<boolean> {
	if (friend.source === "invitation") return true
	return requirePermission({
		...rest,
		permission: "chat_found_friends",
		intent: null,
	})
}
